import styled from 'styled-components';

const paddingSpacingMultiplier = 2;

const Paper = styled.div`
  padding: ${({ theme }) => theme.spacing * paddingSpacingMultiplier}px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  overflow: hidden;
`;

export const FullWidthPaperContent = styled.div`
  margin: 0 ${({ theme }) => theme.spacing * -paddingSpacingMultiplier}px;
  &:first-child{
    margin-top:${({ theme }) => theme.spacing * -paddingSpacingMultiplier}px;
  }
  &:last-child{
    margin-bottom:${({ theme }) => theme.spacing * -paddingSpacingMultiplier}px;
  }
`;

export default Paper;
